<template>
  <b-card no-body>
    <b-card-header class="d-flex align-items-center justify-content-between">
      <b-card-title>
        {{ dataItem.title }}
        <div class="font-small-3 text-muted">
          Kritik Bilgiler
        </div>
      </b-card-title>
      <b-card-sub-title>
        Ürün Kodu: {{ dataItem.pcode }}
      </b-card-sub-title>
    </b-card-header>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="loading"
      :empty-text="emptyText"
      :show-empty="!!emptyText"
    >
      <template #cell(title)="data">
        {{ data.item.title }}
        <template v-if="controlProductFileVersions">
          <b-badge
            v-if="data.item.CurrentVersion.version"
            variant="light-info"
            class="mr-1"
          >
            {{ data.item.CurrentVersion.version }}
          </b-badge>
        </template>
        <div class="mt-1">
          <b-badge
            v-if="data.item.document_groups"
            variant="light-primary"
            class="mr-1"
          >
            <feather-icon icon="FolderIcon" />
            {{ data.item.document_groups }}
          </b-badge>
          <template v-if="controlProductFileVersions">
            <template v-if=" data.item.CurrentVersion.status === 'draft'">
              <b-badge
                variant="light-secondary"
                class="mr-1"
              >
                Taslak
              </b-badge>
            </template>
            <template v-if=" data.item.CurrentVersion.status === 'alpha'">
              <b-badge
                variant="light-warning"
                class="mr-1"
              >
                Test / Alpha
              </b-badge>
            </template>
            <template v-if=" data.item.CurrentVersion.status === 'released'">
              <b-badge
                variant="light-success"
                class="mr-1"
              >
                Yayınlanmış/Kararlı
              </b-badge>
            </template>
            <template v-if=" data.item.CurrentVersion.status === 'deprecated'">

              <b-badge
                variant="light-danger"
                class="mr-1"
              >
                Kullanımdan Kaldırılmış/Eski
              </b-badge>
            </template>
          </template>
        </div>
      </template>
      <template #cell(file_size)="data">
        <div>{{ data.item.file_size | fileSizeFromKB }}</div>
      </template>
      <template #cell(username)="data">
        {{ data.item.username }}
        <div v-if="data.item.created">
          <small class="text-primary">
            <feather-icon icon="SaveIcon" />
            {{ moment(data.item.created).format('DD.MM.YYYY HH:mm:ss') }}
          </small>
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <download-file
            file-component="products"
            :file-id="Number(data.item.id)"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-if="dataCounts > perPage"
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BPagination, BCardFooter, BBadge, BCardTitle, BCardHeader, BCardSubTitle,
} from 'bootstrap-vue'
import DownloadFile from '@/layouts/components/DownloadFile.vue'

const tableName = 'product_files'
export default {
  name: 'ProductsSecretFilesCard',
  components: {
    BCardSubTitle,
    BCardHeader,
    BCardTitle,
    DownloadFile,
    BCard,
    BTable,
    BPagination,
    BCardFooter,
    BBadge,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      userData: JSON.parse(localStorage.getItem('userData')),

      fields: [
        {
          key: 'title',
          label: 'Başlık',
        },
        {
          key: 'file_size',
          label: 'BOYUT',
          thClass: 'width-100 text-nowrap text-right',
          tdClass: 'width-100 text-nowrap text-right',
        },
        {
          key: 'username',
          label: 'Ekleyen',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.file_size AS file_size`,
          `${tableName}.created AS created`,
          'document_groups.title AS document_groups',
          'users.name AS username',
        ],
        where: {
          'product_files.is_secret': '1',
          'product_files.id_products': this.$route.params.id,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    emptyText() {
      if (this.loading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    loading() {
      return this.$store.getters['productFiles/secretLoading']
    },
    dataList() {
      return this.$store.getters['productFiles/secretDataList']
    },
    dataCounts() {
      return this.$store.getters['productFiles/dataSecretCounts']
    },
    controlProductFileVersions() {
      // userData içindeki packageLimits array'inde subject'i PRODUCT_FILE_VERSIONS olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'PRODUCT_FILE_VERSIONS',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataQuery.where['product_files.id_products'] = this.$route.params.id
      this.$store.dispatch('productFiles/getDataSecretList', this.dataQuery)
    },
  },
}
</script>
